import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Sidebar from './sidebar';
import ScrollAnimation from 'react-animate-on-scroll';

class NCVTDetails extends Component {

    render() {

        let publicUrl = process.env.PUBLIC_URL+'/'

    return  <div className="course-single-area pd-top-120 pd-bottom-110">
		  <div className="container">
		    <div className="row">
		      <div className="col-lg-8 ">
		        <div className="event-detaila-inner">
				  <ScrollAnimation animateIn="fadeInRight">
				  <h4>NCVT: Recognition no: 6/22/79/1994-TC</h4>
				  <p>Are you crafty enough to attain more skills and stand out from the crowd? Then NCVT is the right choice for your career. </p>
				  <p>MIET NCVT (National Council of Vocational Training) established in the year 1998 is approved by the Govt of India and initiated by the DGET (Directorate General Employment & Training) and DET (Department of Employment & Training), Govt. of Tamil Nadu  is a course that enables students to develop skills needed for any sector-specific. </p>
		          <p><b>Equivalency:</b> As per the G.O. Ms. No. 34, dt: 30.03.2022,</p>
				  <p>Students who have cleared 10th and have successfully completed any of the 2-year regular ITI course under CTS and have acquired Senior Secondary Certificate from NIOS on completion of requirements as per the Notification: 268/2016 of NIOS dated: 18.07.2016 is considered as equivalent as <i>12th standard completion by the State Board of TamilNadu Government.</i></p>
				  </ScrollAnimation>
				  <ScrollAnimation animateIn="fadeInRight">
				  	<div className='blog-details-page-content'>
					<blockquote>
						<h5 className="mb-0 mt-2">Why MIET?</h5><br/>
						<ul className="single-list-wrap">
							<li className="single-list-inner style-check">
								<i className="fa fa-check" />  Well-trained tutors that culminate and develop students to be “Industry ready”.
							</li>
							<li className="single-list-inner style-check">
								<i className="fa fa-check" /> Structured Syllabus to study in an easy format.
							</li>
							<li className="single-list-inner style-check">
								<i className="fa fa-check" /> Hands-on Experience while studying.
							</li>
							<li className="single-list-inner style-check">
								<i className="fa fa-check" /> Regular tests to be strong in Theory and Practical Knowledge.
							</li>
							<li className="single-list-inner style-check">
								<i className="fa fa-check" /> Enhancing Interpersonal skills to stand out Successful.
							</li>
						</ul>
					</blockquote>
					</div>
					<i>And that’s not all:</i><br/><br/>
					</ScrollAnimation>
					<ScrollAnimation animateIn="fadeInRight">
					<p><b>MIET-ITI</b> is one of the largest private ITIs in the city with several trades under one roof. We stand proud to inform you that our ITI is positioned in the Top Listed Private ITIs that are based on the Grading system done by NCVT which is recognised by the Government of India.</p>
					</ScrollAnimation>
					<ScrollAnimation animateIn="fadeInRight">
					<div className='blog-details-page-content'>
						<blockquote>
							<p><b>Admissions: [March - September]</b></p>
							<p><b>Eligibility: </b></p>
							<ul>
								<li>10th pass</li>
								<li>Age: 14-40 years</li>
							</ul>
						</blockquote>
					</div>
					</ScrollAnimation>
					<ScrollAnimation animateIn="fadeInRight">
					<table>
						<tr>
							<th>Course</th>
							<th>Duration</th>
						</tr>
						<tr>
							<td>Refrigeration & Air Conditioning</td>
							<td>2 Years</td>
						</tr>
						<tr>
							<td>Electrician	</td>
							<td>2 Years</td>
						</tr>
						<tr>
							<td>Fitter	</td>
							<td>2 Years</td>
						</tr>
						<tr>
							<td>Mechanic Motor Vehicle</td>
							<td>2 Years</td>
						</tr>
						<tr>
							<td>Electronics Mechanic	</td>
							<td>2 Years</td>
						</tr>
					</table>
					</ScrollAnimation>
					<ScrollAnimation animateIn="fadeInRight">
					<div className='blog-details-page-content'>
						<blockquote>
							<h5 className="mb-0 mt-2">Syllabus:</h5><br/>
							<ul className="single-list-wrap">
								<li className="single-list-inner style-check">
									<i className="fa fa-check" /> Professional skill / Trade Practical
								</li>
								<li className="single-list-inner style-check">
									<i className="fa fa-check" /> Professional knowledge / Trade theory
								</li>
								<li className="single-list-inner style-check">
									<i className="fa fa-check" /> Workshop Science & calculation
								</li>
								<li className="single-list-inner style-check">
									<i className="fa fa-check" />  Engineering drawing
								</li>
							</ul>
						</blockquote>
					</div>
					</ScrollAnimation>
					<ScrollAnimation animateIn="fadeInRight">
						<h5 className="mb-0 mt-2">Dual System of Training:</h5><br/>
						<p>The Dual System of Training launched by the DGT in Feb. 2019 has an aim to provide employable skills to the trainees who are clear from ITIs in various trades.</p>
						<p>Its objective is to enable Industries to partner with Government and Private ITIs to conduct training programmes under high employability courses for individuals to enhance their required skills.</p>
		          		<p>Trainees who have completed the course are awarded National Trade Certificate (NTC) and have an advantage over regular ITI pass-outs in employment opportunities in the Industry.</p>
				  		<p><b>MIET</b> guides you to explore all opportunities to the full extent and be successful in the career of your choice. </p>
					</ScrollAnimation>
					<ScrollAnimation animateIn="fadeInRight">
						  <h5 className="mb-0 mt-2">National Apprenticeship Training (NATS):</h5><br/>
				  		<p>MIET guides its students to be recognised all over India through the National Apprenticeship Training Programme offered by NCVT which is a year-long training to equip them with the best practical skills and knowledge in the field of their work. </p>
						<p>The trainees during their apprenticeship period are paid a stipend of which 50% is reimbursable to the employer from the Government of India. Upon completion of the training period, the trainee receives a Certificate of Proficiency by the Government which is registered at all employment exchanges across India and is valid as an employment experience. </p>
				  		<p>It is one of the Flagship Programmes of The Government of India initiated for the Indian Youth.</p>
					</ScrollAnimation>
					<ScrollAnimation animateIn="fadeInRight">
						  <div className='blog-details-page-content'>
						<blockquote>
							<h5 className="mb-0 mt-2">Qualifications:</h5><br/>
							<ul className="single-list-wrap">
								<li className="single-list-inner style-check">
									<i className="fa fa-check" />The candidate’s age limit to be above 16 years, as on the date of application as per the age criteria that are prescribed are eligible for the skill development programme of NATS.
								</li>
								<li className="single-list-inner style-check">
									<i className="fa fa-check" /> Applicant must hold a degree/diploma certificate to apply for this scheme
								</li>
								<li className="single-list-inner style-check">
									<i className="fa fa-check" />The candidates who are already trained under any other Government training programme of skill development are not eligible under this scheme.
								</li>
								<li className="single-list-inner style-check">
									<i className="fa fa-check" />The candidates should not be self-employed
								</li>
								<li className="single-list-inner style-check">
									<i className="fa fa-check" />The candidates must not be a dismissed Government employee.
								</li>
							</ul>
						</blockquote>
					</div>
					</ScrollAnimation>
					<ScrollAnimation animateIn="fadeInRight">
				  	<div className='blog-details-page-content'>
					<blockquote>
						<h5 className="mb-0 mt-2">Application Form:</h5><br/>
						<Link to="/online-payment"><button className="btn btn-base" style={{color:'white',fontWeight:'700'}}>Visit</button></Link>
					</blockquote>
					</div>
					</ScrollAnimation>
				  </div>
		      </div>
			  <Sidebar courseRestriction="NCVT" />
		    </div>
		  </div>
		</div>

        }
}

export default NCVTDetails